<template>
  <form
    @submit.prevent="onSave">
    <fixed-header id="sticky-header">
      <div class="row form-header py-2">
        <div class="col-sm-4 col-xl-4 m-auto">
          <a class="h6" href="javascript:void(0)"
            @click="onView"
          >
            <i class="uil-arrow-left"></i> {{$t('common.back_to').toUpperCase()}} {{$t('user.singular').toUpperCase()}}
          </a>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          <div class="btn-group d-sm-inline-block">
              <button 
                type="submit" 
                class="btn2 btn2-primary btn-sm"
              ><i class="uil uil-edit mr-1"></i>{{$t('common.save')}}</button>
          </div>
        </div>
        
      </div>
    </fixed-header>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('user.form.user_information')}}</h4>
            <p class="sub-header"></p>

            <div class="row">

              <div class="col-6" v-if="type == 'users'">
                <DropDown 
                  :placeholder="$t('user.form.access_type.placeholder')"
                  :label="$t('user.form.access_type.label')"
                  :name.sync="model.access_type"
                  :error="$v.model.access_type.$error"
                  :errorMessage="$v.model.access_type.errorMessage"
                  :options="access_type_options" 
                />
              </div>

              <div class="col-6" v-if="model.access_type == 'recruitment'">
                <DropDown 
                  :placeholder="$t('user.form.recruitment_type.placeholder')"
                  :label="$t('user.form.recruitment_type.label')"
                  :name.sync="model.recruitment_type"
                  :options="recruitment_type_options"
                />
              </div>
            </div>

            <div class="row" v-if="type != 'company'">

              <div class="col-6">
                <TextField 
                  :placeholder="$t('user.form.first_name.placeholder')"
                  :label="$t('user.form.first_name.label')"
                  v-model="model.first_name"
                  :error="$v.model.first_name.$error"
                  :errorMessage="$v.model.first_name.errorMessage"
                />
              </div>
              

              <div class="col-6">
                <TextField 
                  :placeholder="$t('user.form.last_name.placeholder')"
                  :label="$t('user.form.last_name.label')"
                  v-model="model.last_name"
                  :error="$v.model.last_name.$error"
                  :errorMessage="$v.model.last_name.errorMessage"
                />
              </div>
            </div>

            <div class="row" v-if="type == 'company'">
              <div class="col-12">
                <TextField 
                  placeholder="Enter Company"
                  label="Company Name"
                  v-model="model.company_name"
                  :error="$v.model.company_name.$error"
                  :errorMessage="$v.model.company_name.errorMessage"
                />
              </div>
            </div>

            <div class="row">
              <div class=" col-md-12">
                <div class="form-group">
                  <label for="" class="form-label">{{ $t('user.form.industry.label') }}</label>
                  <multiselect
                    v-model="model.industry_id"
                    :options="industry_options"
                    :searchable="true"
                    :multiple="true"
                    :placeholder="$t('user.form.industry.placeholder')"
                    :clear-on-select="false"
                    :close-on-select="false"
                    :show-labels="false"

                    track-by="_id"
                    label="name"
                  ></multiselect>
                </div>
              </div>
              

              <div class="col-md-12">
                <div class="form-group">
                  <label for="" class="form-label">{{$t('user.form.function.label')}}</label>
                    <multiselect
                    v-model="model.function_id"
                    :options="function_options"
                    :searchable="true"
                    :multiple="true"
                    :placeholder="$t('user.form.function.placeholder')"
                    :clear-on-select="false"
                    :close-on-select="false"
                    :show-labels="false"

                    track-by="_id"
                    label="name"
                  ></multiselect>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('user.form.security_settings')}}</h4>
            <p class="sub-header"></p>
            <TextField 
                placeholder="hello@hrtech.com"
                :label="$t('user.form.email.label')"
                type="email"
                autocomplete="off"
                v-model="model.email"
                :error="$v.model.email.$error"
                :errorMessage="$v.model.email.errorMessage"
              />

            <TextField 
                :placeholder="$t('user.form.password.placeholder')"
                :label="$t('user.form.password.label')"
                type="password"
                autocomplete="off"
                v-model="model.password"
                :error="$v.model.password.$error"
                :errorMessage="$v.model.password.errorMessage"
              />

            <TextField 
              :placeholder="$t('user.form.confirm_password.placeholder')"
              :label="$t('user.form.confirm_password.label')"
              type="password"
              :value="model.confirm_password"
              v-model="model.confirm_password"
              :error="$v.model.confirm_password.$error"
            />
          </div>
        </div>
      </div>

      <div class="col-md-8" v-if="type == 'company'">
        <div class="card">
          <div class="card-body">
            <div class="row" >
            <div class="col-md-4">
              <TextField 
                placeholder="Enter Contact Person"
                label="Contact Person"
                :value="model.contact_person"
              />
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="">Contract Start Date</label>
                <flat-pickr
                  v-model="model.contract_start_date"
                  class="form-control"
                  placeholder="Enter your Date"
                ></flat-pickr>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="">Contract End Date</label>
                <flat-pickr
                  v-model="model.contract_end_date"
                  class="form-control"
                  placeholder="Enter your Date"
                ></flat-pickr>
              </div>
            </div>
            <div class="col-md-12">
              <vue-editor height="300"
                placeholder="Enter Company Description"
                v-model="model.company_details">
              </vue-editor>
            </div>
          </div>
          </div>
        </div>
        
      </div>
      
      
      <!-- end col -->
    </div>

  </form>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import TextField from '@components/form/textfield.vue'
import DropDown from '@components/form/dropdown.vue'
import { required, email, sameAs, requiredIf} from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import { VueEditor } from 'vue2-editor'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [FormMixin],
  components:{FixedHeader, TextField, DropDown, VueEditor, Multiselect},
  data(){
    var type = this.$route.query.type,
      aoptions = [{ value: null, text: 'Please select a Type' }]
    
    if(type == 'users'){
      aoptions.push({ value: 'administration', text: 'Administrator' })
      aoptions.push({ value: 'staff', text: 'Staff' })
    }

    //aoptions.push({ value: 'recruitment', text: 'Recruitment' })
    return {
      type:type,
      model:{
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirm_password: '',
        access_type:null,
        recruitment_type:null
      },
      industry_options:[],
      function_options:[],
      access_type_options: aoptions,
      recruitment_type_options: [
        { value: null, text: 'Please select a Type' },
        { value: 'company', text: 'Company' },
        { value: 'individual', text: 'Individual' }
      ],
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth
    }
  },
  validations: {
    model:{
      first_name: { 
        required: requiredIf(function(){
          return this.type != 'company'
        })
       },
      last_name: { 
        required: requiredIf(function(){
          return this.type != 'company'
        })
      },
      company_name:{
        required: requiredIf(function(){
          return this.type == 'company'
        })
      },
      email: {
        required,
        email
      },
      password: {
        required
      },
      access_type: {
        required: requiredIf(function(){
          return this.type == 'users'
        })
      },
      confirm_password: {
        sameAsPassword: sameAs('password')
      }
    }
  },
  async beforeMount(){
    this.fetchData()
    await this.$store.dispatch('industry/all').then(data => {
      data.data.forEach(el => {
        this.industry_options.push(el) 
      })
    })

    await this.$store.dispatch('function/all').then(data => {
      data.data.forEach(el => {
        this.function_options.push(el) 
      })
    })
  },
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  updated(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    onView() {
      this.$router.push('/administration/user')
    },
    ...mapActions('user', ['create']),
    onSave() {

      if (this.validateForm()) {
				this.toggleLoading()
				return;
			}

      this.model._type = this.type
      this.model.pid = this.$route.query.id

      this.create(this.model)
      .then(()=> {
        this.toggleLoading()
         this.$router.push('/administration/user')
      })
      .catch((err) => {
        this.toggleLoading()

        Object.keys(err.response.data).forEach(key => {
          if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
        })

        this.setError(err.response.data.msg)

      })
    },
    async fetchData(){
     /*  await this.find({
        id:this.$route.query.id
      }).then(data => {
        this.model = data.data
        this.model.rate = data.data.rate.$numberDecimal
      }) */
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onCancel() {
      this.$router.push('/administration/user')
    }
  },
  watch:{
    'model.access_type':{
      handler: function() {
        if(this.model.access_type != 'recruitment_type'){
          this.model.recruitment_type = null
        }
      }
    }
  }
}
</script>

